"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMessage = buildMessage;
const util_typescript_1 = require("@varos/util-typescript");
function buildMessage(props) {
    if (props.kind === 'text') {
        return {
            id: props.id,
            kind: 'text',
            role: props.role,
            content: props.content,
            committed: props.committed,
        };
    }
    if (props.kind === 'audio') {
        return {
            id: props.id,
            kind: 'audio',
            role: props.role,
            transcript: props.transcript,
            durationMs: props.durationMs,
            committed: props.committed,
        };
    }
    (0, util_typescript_1.assertNever)(props);
}
//# sourceMappingURL=messageFactory.js.map